import { z } from 'zod'

// Button color variants
export const buttonColorVariantSchema = z.enum(['OUTLINE', 'DESTRUCTIVE'])
export type ButtonColorVariant = z.infer<typeof buttonColorVariantSchema>

export const buttonConfigurationSchema = z.object({
  colorVariant: buttonColorVariantSchema,
})

export type ButtonConfiguration = z.infer<typeof buttonConfigurationSchema>
